import {Estado} from "./estado";

export class Municipio {
	public cod_ibge_estimativa_populacao: number;
	public cod_municipio: number;
	public txt_sigla_uf: string;
	public txt_nome_municipio: string;
	public num_populacao_estimada: number;
	public cod_uf: number;
	public estado?: Estado;
}